import { Rectangle } from '@src/slide/infrastructure/module/independent/quadtree/rectangle';

export function checkRectIntersection(rect1: Rectangle<any>, rect2: Rectangle<any>): boolean {
    const { x: x1, y: y1, width: width1, height: height1 } = rect1;
    const { x: x2, y: y2, width: width2, height: height2 } = rect2;
    return (
        (x1 - (x2 + width2)) < 1e-4
        && x1 + width1 - x2 > 1e-4
        && (y1 - (y2 + height2)) < 1e-4
        && y1 + height1 - y2 > 1e-4
    );
}
